import * as React from 'react'
import { Link } from '$views/components/Link'
import { DropdownMenu, DropdownItem } from '$views/components/DropdownMenu'
import { Icon } from '$views/components/Icon'
import { HeaderWrapper, HeaderLogo, HeaderDiv, StyledLink, PremiumProImage } from './HomeHeader.style'
import { routeProvider } from '$utils/routeProvider'
import { theme } from '$utils/theme'
import { Block } from '../Block'
import { localUserIdData } from '$utils/services/saveUserIdDataService/saveUserIdDataService'
import { useUnreadMessages } from '$utils/hooks/useUnreadMessages'
import { isUserAuthenticated } from '$services/session/isAuthenticated/isAuthenticated.service'
import { userGroupService } from '$utils/services/userGroupService'
import history from '$utils/history'
import { logoutUser } from '$services/session/logout/logout.service'
import { MediaQueryOwn } from '$views/components/MediaQueryOwn'

const logo = require('$icons/logoFamiliados.svg')
const pro = require('$icons/pro.svg')

export const HomeHeader: React.FC = ({ children }) => {
  const isUnreadMessages = useUnreadMessages()
  const [isAuthenticated, setIsAuthenticated] = React.useState<boolean>(isUserAuthenticated())

  const onClickLogo = () => history.push(routeProvider.mainPage)

  const onClickPro = () => history.push(routeProvider.caretakerPro)

  const onClickLogin = () => history.push(routeProvider.login)

  const onClickStart = () => history.push(routeProvider.myUserArea)

  const onClickCustomerSearcher = () => history.push(routeProvider.caretakerList)

  const onClickMyServices = () => history.push(routeProvider.myServices)

  const onClickMyProfile = () => history.push(routeProvider.profile)

  const onClickSettings = () => history.push(routeProvider.settings)

  const onClickMyPrivateArea = () => window.location.assign(routeProvider.clientProfile)

  const onClickOffers = () => history.push(routeProvider.offersForCaretaker)

  const onClickMessages = () => history.push(routeProvider.chat)

  const onClickImagesReviews = () => history.push(routeProvider.imagesReviews)

  const onClickLogout = async () => {
    await logoutUser()
    setIsAuthenticated(false)
  }

  const onClickHelp = () => window.location.assign(routeProvider.help)

  const onClickNursingHomeHelp = () => window.location.assign(routeProvider.nursingHomeHelp)

  if (!isAuthenticated) {
    return (
      <>
        <HeaderWrapper>
          <HeaderDiv>
            <HeaderLogo>
              <Link onClick={onClickLogo} title="Familiados" href="#">
                <Icon content={logo} logo color="darkGrey" />
              </Link>
            </HeaderLogo>
            <MediaQueryOwn minWidth={theme.breakpoints.desktop}>
              <Block>
                <StyledLink onClick={onClickCustomerSearcher} title="Profesionales en tu zona" color="darkGrey">
                  Profesionales en tu zona
                </StyledLink>
                <StyledLink onClick={onClickHelp} title="Ayuda" color="darkGrey">
                  Ayuda
                </StyledLink>
                <StyledLink onClick={onClickLogin} title="Entrar" color="darkGrey">
                  Entrar
                </StyledLink>
              </Block>
            </MediaQueryOwn>
            <MediaQueryOwn maxWidth={theme.breakpoints.desktop - 1}>
              <DropdownMenu>
                <DropdownItem onClick={onClickCustomerSearcher}>Profesionales en tu zona</DropdownItem>
                <DropdownItem onClick={onClickHelp}>Ayuda</DropdownItem>
                <DropdownItem lastItem onClick={onClickLogin}>
                  Entrar
                </DropdownItem>
              </DropdownMenu>
            </MediaQueryOwn>
          </HeaderDiv>
        </HeaderWrapper>
        <MediaQueryOwn maxWidth={theme.breakpoints.desktop - 1} />
        {children}
      </>
    )
  }
  if (userGroupService.isNormalCustomer()) {
    return (
      <>
        <HeaderWrapper>
          <HeaderDiv>
            <HeaderLogo>
              <Link onClick={onClickLogo} title="Familiados">
                <Icon content={logo} logo color="darkGrey" />
              </Link>
            </HeaderLogo>
            {!userGroupService.isGuest() && (
              <>
                <DropdownMenu color="darkGrey">
                  <DropdownItem onClick={onClickStart}>Inicio</DropdownItem>
                  <DropdownItem onClick={onClickMyServices}>Mis servicios</DropdownItem>
                  <DropdownItem onClick={onClickMessages} circle={isUnreadMessages}>
                    Chat
                  </DropdownItem>
                  <DropdownItem onClick={onClickCustomerSearcher}>Profesionales en tu zona</DropdownItem>
                  <DropdownItem onClick={onClickMyProfile}>Mi perfil</DropdownItem>
                  <DropdownItem onClick={onClickSettings}>Ajustes</DropdownItem>
                  <DropdownItem lastItem onClick={onClickLogout}>
                    Cerrar sesión
                  </DropdownItem>
                </DropdownMenu>
              </>
            )}
          </HeaderDiv>
        </HeaderWrapper>
        {children}
      </>
    )
  }
  if (userGroupService.isResidenceAdmin() || userGroupService.isResidenceModerator()) {
    return (
      <>
        <HeaderWrapper>
          <HeaderDiv>
            <HeaderLogo>
              <Link onClick={onClickLogo} title="Familiados">
                <Icon content={logo} logo color="darkGrey" />
              </Link>
            </HeaderLogo>
            <MediaQueryOwn minWidth={theme.breakpoints.desktop}>
              <Block marginRight="small">
                <StyledLink onClick={onClickCustomerSearcher} title="Profesionales en tu zona" color="darkGrey">
                  Profesionales en tu zona
                </StyledLink>
              </Block>
            </MediaQueryOwn>
            <DropdownMenu color="darkGrey">
              <MediaQueryOwn maxWidth={theme.breakpoints.desktop - 1}>
                <DropdownItem onClick={onClickCustomerSearcher}>Profesionales en tu zona</DropdownItem>
              </MediaQueryOwn>
              <DropdownItem onClick={onClickMyServices}>Mi área privada</DropdownItem>
              <DropdownItem onClick={onClickSettings}>Ajustes</DropdownItem>
              <DropdownItem onClick={onClickNursingHomeHelp}>Ayuda</DropdownItem>
              <DropdownItem lastItem onClick={onClickLogout}>
                Cerrar sesión
              </DropdownItem>
            </DropdownMenu>
          </HeaderDiv>
        </HeaderWrapper>
        {children}
      </>
    )
  }
  if (userGroupService.isCallcenter()) {
    return (
      <>
        <HeaderWrapper>
          <HeaderDiv>
            <HeaderLogo>
              <Link onClick={onClickLogo} title="Familiados">
                <Icon content={logo} logo color="darkGrey" />
              </Link>
            </HeaderLogo>
            <MediaQueryOwn minWidth={theme.breakpoints.desktop}>
              <Block marginRight="small">
                <StyledLink onClick={onClickCustomerSearcher} title="Profesionales en tu zona" color="darkGrey">
                  Profesionales en tu zona
                </StyledLink>
              </Block>
            </MediaQueryOwn>
            <DropdownMenu color="darkGrey">
              <MediaQueryOwn maxWidth={theme.breakpoints.desktop - 1}>
                <DropdownItem onClick={onClickCustomerSearcher}>Profesionales en tu zona</DropdownItem>
              </MediaQueryOwn>
              <DropdownItem onClick={onClickMyServices}>Mis servicios</DropdownItem>
              <DropdownItem onClick={onClickMyProfile}>Mi perfil</DropdownItem>
              <DropdownItem lastItem onClick={onClickLogout}>
                Cerrar sesión
              </DropdownItem>
            </DropdownMenu>
          </HeaderDiv>
        </HeaderWrapper>
        {children}
      </>
    )
  }
  if (userGroupService.isCaretaker()) {
    return (
      <>
        <HeaderWrapper>
          <HeaderDiv>
            <HeaderLogo>
              <Link onClick={onClickLogo} title="Familiados">
                <Icon content={logo} logo color="darkGrey" />
              </Link>
            </HeaderLogo>
            {!localUserIdData.getUserIdData().hasActiveProSubscription && (
              <PremiumProImage content={pro} onClick={onClickPro} clickable resize={{ height: 25, width: 80 }} />
            )}
            <DropdownMenu color="darkGrey">
              <DropdownItem onClick={onClickOffers}>Ofertas</DropdownItem>
              <DropdownItem onClick={onClickMyServices}>Mis servicios</DropdownItem>
              <DropdownItem onClick={onClickMessages} circle={isUnreadMessages}>
                Chat
              </DropdownItem>
              <DropdownItem onClick={onClickMyProfile}>Mi perfil</DropdownItem>
              <DropdownItem onClick={onClickSettings}>Ajustes</DropdownItem>
              <DropdownItem lastItem onClick={onClickLogout}>
                Cerrar sesión
              </DropdownItem>
            </DropdownMenu>
          </HeaderDiv>
        </HeaderWrapper>
        {children}
      </>
    )
  }

  return (
    <>
      <HeaderWrapper>
        <HeaderDiv>
          <HeaderLogo>
            <Link onClick={onClickLogo} title="Familiados">
              <Icon content={logo} logo />
            </Link>
          </HeaderLogo>
          {!userGroupService.isGuest() && (
            <>
              {!userGroupService.isRecruiter() && (
                <MediaQueryOwn minWidth={theme.breakpoints.desktop}>
                  <Block marginRight="small">
                    <StyledLink onClick={onClickCustomerSearcher} title="Profesionales en tu zona" color="darkGrey">
                      Profesionales en tu zona
                    </StyledLink>
                  </Block>
                </MediaQueryOwn>
              )}
              <DropdownMenu color="darkGrey">
                {!userGroupService.isRecruiter() && (
                  <MediaQueryOwn maxWidth={theme.breakpoints.desktop - 1}>
                    <DropdownItem onClick={onClickCustomerSearcher}>Profesionales en tu zona</DropdownItem>
                  </MediaQueryOwn>
                )}
                <DropdownItem onClick={onClickMyPrivateArea}>Mi área privada</DropdownItem>
                {userGroupService.isAdmin() && (process.env.REACT_APP_AUXILIARES as string) === 'true' && (
                  <DropdownItem onClick={onClickImagesReviews}>Revisión imágenes</DropdownItem>
                )}
                <DropdownItem lastItem onClick={onClickLogout}>
                  Cerrar sesión
                </DropdownItem>
              </DropdownMenu>
            </>
          )}
        </HeaderDiv>
      </HeaderWrapper>
      {children}
    </>
  )
}



// WEBPACK FOOTER //
// ./src/views/components/Layout/HomeHeader/HomeHeader.tsx